import { getTimezoneDayjs } from '@/utils/time';

import type { DateRange } from './types';

export enum PresetName {
  LAST_WEEK = 'lastWeek',
  LAST_MONTH = 'lastMonth',
  LAST7 = 'last7',
  LAST14 = 'last14',
  LAST30 = 'last30',
  LAST60 = 'last60',
  LAST90 = 'last90',
  THIS_MONTH = 'thisMonth',
  THIS_YEAR = 'thisYear',
}

export interface Preset {
  name: PresetName;
  label: string;
}

// Define presets
export const PRESETS: Preset[] = [
  // 현재로선 오늘 데이터가 없어서 주석 처리해둡니다. 나중에 필요해지면 다시 주석을 제거해주세요.
  // { name: PresetName.TODAY, label: 'Today' },
  { name: PresetName.LAST_WEEK, label: 'Last week' },
  { name: PresetName.LAST_MONTH, label: 'Last month' },
  { name: PresetName.LAST7, label: 'Last 7 days' },
  { name: PresetName.LAST14, label: 'Last 14 days' },
  { name: PresetName.LAST30, label: 'Last 30 days' },
  { name: PresetName.LAST60, label: 'Last 60 days' },
  { name: PresetName.LAST90, label: 'Last 90 days' },
  { name: PresetName.THIS_MONTH, label: 'This month' },
  { name: PresetName.THIS_YEAR, label: 'This year' },
];

export const getPresetDateRange = (presetName: PresetName): DateRange => {
  const preset = PRESETS.find(({ name }) => name === presetName);
  if (!preset) {
    throw new Error(`Unknown date range preset: ${presetName}`);
  }

  const from = getTimezoneDayjs();
  const to = getTimezoneDayjs();

  switch (preset.name) {
    case PresetName.LAST_WEEK:
      return {
        from: from.subtractVal(1, 'week').startOf('week').tz(),
        to: to.subtractVal(1, 'week').endOf('week').tz(),
      };
    case PresetName.LAST_MONTH:
      return {
        from: from.subtractVal(1, 'month').startOf('month').tz(),
        to: to.subtractVal(1, 'month').endOf('month').tz(),
      };
    case PresetName.LAST7:
      return {
        from: from.subtractVal(6, 'day').startOf('day').tz(),
        to: to.endOf('day').tz(),
      };
    case PresetName.LAST14:
      return {
        from: from.subtractVal(13, 'day').startOf('day').tz(),
        to: to.endOf('day').tz(),
      };
    case PresetName.LAST30:
      return {
        from: from.subtractVal(29, 'day').startOf('day').tz(),
        to: to.endOf('day').tz(),
      };
    case PresetName.LAST60:
      return {
        from: from.subtractVal(59, 'day').startOf('day').tz(),
        to: to.endOf('day').tz(),
      };
    case PresetName.LAST90:
      return {
        from: from.subtractVal(89, 'day').startOf('day').tz(),
        to: to.endOf('day').tz(),
      };
    case PresetName.THIS_MONTH:
      return {
        from: from.startOf('month').tz(),
        to: to.endOf('month').tz(),
      };
    case PresetName.THIS_YEAR:
      return {
        from: from.startOf('year').tz(),
        to: to.endOf('year').tz(),
      };
  }
};
